import {SCROLL_TO_EVENT_KEY} from './scenes/HotelInfoAccordion/constants';
import {EVENT_BEFORE_SMOOTH_SCROLL} from 'js/constants';

export const scrollToSection = function (id) {
  const event = new CustomEvent(SCROLL_TO_EVENT_KEY, {
    detail: {id}
  })
  window.top.dispatchEvent(event)
}

export const pushBeforeSmoothScroll = function () {
  const event = new CustomEvent(EVENT_BEFORE_SMOOTH_SCROLL)
  window.top.dispatchEvent(event)
}
